
// ===============================
// GLOBAL DATA
// ===============================
const priceMap = window.subscriptionPrices || {};
const containerMap = window.containerValue || {};

console.log(priceMap, "pricemap");
console.log(containerMap, "containerMap");

// ===============================
// STATIC SUBSCRIPTION TEXT
// ===============================
var mainSubshtm = `
<div class="main__options--subscription">
  <ul class="subscription__options">
    <li>
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path d="M18.5769 6.18299C18.8169 7.57699L13.1509 15.597C12.2109 16.866C11.1729 17.726C9.14286 17.879C7.99386 17.177L5.26886 14.308C4.98465 13.5861L5.3022 12.8782C6.03037 12.6105L8.33686 14.666C9.33486 15.693C10.3179 15.918L11.5409 14.409L17.1829 6.42299Z" fill="#2D2D2D"/>
      </svg>
      Pause, update, or cancel anytime
    </li>
  </ul>
</div>
`;

// ===============================
// DEFAULT IMAGE
// ===============================
const defaultBottleImg = 'https://cdn.shopify.com/s/files/1/your-default-bottle-image.svg';

// ===============================
// HELPERS
// ===============================
function getMetafield(metafieldKey) {
  const productMetaScript = document.querySelector('#product-metafields');

  if (productMetaScript) {
    try {
      const data = JSON.parse(productMetaScript.textContent);
      if (data.metafields && data.metafields[metafieldKey]) {
        return data.metafields[metafieldKey];
      }
    } catch (e) {
      console.error('Error parsing metafields:', e);
    }
  }

  const metaElement = document.querySelector(`[data-metafield="${metafieldKey}"]`);
  if (metaElement) {
    return metaElement.textContent || metaElement.value || metaElement.getAttribute('content');
  }

  return null;
}

function extractNumber(text) {
  if (!text) return null;
  const match = text.match(/\d+/);
  return match ? parseInt(match[0], 10) : null;
}

function generateRepeatedImages(imgUrl, count, altText) {
  let imagesHTML = '';
  for (let i = 0; i < count; i++) {
    imagesHTML += `<img src="${imgUrl}" alt="${altText}" width="71" height="40" loading="lazy">`;
  }
  return imagesHTML;
}

// ===============================
// GENERATE OPTIONS
// ===============================
function generateOnetimeOptions() {

  const subscriptionData = [
    { id: 'one-time-zero', defaultValue: '1', containerKey: 'option1', priceKey: 'option1' },
    { id: 'one-time-one', defaultValue: '2', containerKey: 'option2', priceKey: 'option2' },
    { id: 'one-time-two', defaultValue: '3', containerKey: 'option3', priceKey: 'option3' },
    { id: 'one-time-three', defaultValue: '6', containerKey: 'option4', priceKey: 'option4' }
  ];

  let optionsHTML = '<div class="one__timeoption--wrapper"><div class="one__timeoption--inner">';

  subscriptionData.forEach((item, index) => {

    // TEXT (with fallback)
    const bottleText = containerMap[item.containerKey] || `${item.defaultValue} bottle`;

    // QUANTITY
    const extractedNumber = extractNumber(bottleText);
    const repeatCount = extractedNumber || parseInt(item.defaultValue, 10);

    // IMAGE
    const imgUrl = getMetafield('custom.subscription_img_1') || defaultBottleImg;

    // PRICE
    const priceText = priceMap[item.priceKey] || '';

    const isChecked = index === 0 ? 'checked' : '';

    const repeatedImages = generateRepeatedImages(imgUrl, repeatCount, bottleText);

    optionsHTML += `
      <div class="main--option ${item.id}">
        <input type="radio" name="subscription-option" value="${repeatCount}" ${isChecked} id="${item.id}" style="display:none;">
        <label for="${item.id}">
          <div class="option__inner--main">
            <div class="option__img">${repeatedImages}</div>
            <div class="option__info">
              ${bottleText}
              <div class="price_btm">${priceText}</div>
            </div>
          </div>
        </label>
      </div>
    `;
  });

  optionsHTML += '</div></div>';
  return optionsHTML;
}

// ===============================
// MAIN LOGIC
// ===============================
var quantityNumber = document.querySelector(".qty-input__input.input");

const observer = new MutationObserver((mutations, obs) => {

  const subtext = document.querySelector("#appstle_subscription_widget0");

  if (subtext) {

    function initSubscriptionLogic() {

      const subtext = document.querySelector("#appstle_subscription_widget0");
      if (!subtext) return;

      // Inject subscription text
      const innersubtext = subtext.querySelector(".appstle_single_option_text");
      if (innersubtext) {
        innersubtext.innerHTML = mainSubshtm;
      }

      // Inject options
      const mainOnetime = subtext.querySelector(".appstle_one_time_description_text");
      if (mainOnetime) {
        mainOnetime.innerHTML = generateOnetimeOptions();
      }

      // ===============================
      // FALLBACK PRICE LOGIC
      // ===============================
      const zeroTime = document.querySelector(".one-time-zero .price_btm");
      if (zeroTime && zeroTime.innerHTML.trim() === '') {
        zeroTime.innerHTML = priceMap.option1 || '';
      }

      const oneTime = document.querySelector(".one-time-one .price_btm");
      if (oneTime && oneTime.innerHTML.trim() === '') {
        oneTime.innerHTML = priceMap.option2 || '';
      }

      const twoTime = document.querySelector(".one-time-two .price_btm");
      if (twoTime && twoTime.innerHTML.trim() === '') {
        twoTime.innerHTML = priceMap.option3 || '';
      }

      const threeTime = document.querySelector(".one-time-three .price_btm");
      if (threeTime && threeTime.innerHTML.trim() === '') {
        threeTime.innerHTML = priceMap.option4 || '';
      }

      // ===============================
      // RADIO CHANGE LOGIC
      // ===============================
      const radios = document.querySelectorAll('input[name="subscription-option"]');

      radios.forEach(radio => {
  if (!radio.dataset.listenerAttached) {
    radio.dataset.listenerAttached = "true";

    radio.addEventListener('change', () => {
      const checked = document.querySelector('input[name="subscription-option"]:checked');
      if (checked && quantityNumber) {
        quantityNumber.value = checked.value;
      }
    });
  }
});

// =============================
// RESET QTY WHEN SWITCHING TO SUBSCRIBE & SAVE
// =============================
const sellingPlanRadios = document.querySelectorAll('input[name="selling_plan"]');
sellingPlanRadios.forEach(radio => {
  if (!radio.dataset.listenerAttached) {
    radio.dataset.listenerAttached = "true";
    radio.addEventListener('change', () => {
      if (radio.checked && radio.value !== '' && quantityNumber) {
        quantityNumber.value = 1;
      }
    });
  }
});
}

    // Re-init on dropdown change
    var customSelect = document.querySelector(".custom-select");
    if (customSelect) {
      var customLis = customSelect.querySelectorAll(".custom-select__option");

      customLis.forEach(function(ele) {
        if (!ele.dataset.listenerAttached) {
          ele.dataset.listenerAttached = "true";

          ele.addEventListener("click", function() {
            setTimeout(initSubscriptionLogic, 200);
          });
        }
      });
    }

    initSubscriptionLogic();
    obs.disconnect();
    }
});

// Start observing
observer.observe(document.body, {
  childList: true,
  subtree: true
});
